import { Skeleton } from '@/src/components/ui/skeleton';
import React from 'react';

const LoadingCart = () => {
  return (
    <div className="mb-3 flex flex-col gap-3 rounded-lg bg-white p-3 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Skeleton className="h-14 w-14 rounded-lg border-2 border-slate-200" />
          <div className="flex flex-col">
            <Skeleton className="mb-2 h-6 w-36" />
            <Skeleton className="h-4 w-24" />
          </div>
        </div>
        <Skeleton className="h-7 w-7 rounded-full" />
      </div>
      <Skeleton className="my-3 h-4 w-48" />
      <Skeleton className="my-3 h-12 w-full" />
      <div className="flex w-full justify-between gap-10">
        <Skeleton className="h-12 w-1/3" />
        <Skeleton className="h-12 w-3/2" />
      </div>
    </div>
  );
};

export default LoadingCart;
